import UserType from "@/constants/user_type";
import Login from "@/views/Login/Login.vue";
import Dashboard from "@/views/Dashboard/Dashboard.vue";
import DashboardClient from "@/views/Dashboard/DashboardClient.vue";
import Sucursales from "@/views/Sucursales/Sucursales.vue";
import Almacenes from "@/views/Almacenes/Almacenes.vue";
import Employees from "@/views/Employees/Employees.vue";
import Operators from "@/views/Operators/Operators.vue";
import Clients from "@/views/Clients/Clients.vue";
import SubClients from "@/views/SubClients/SubClients.vue";
import CategoriasZonas from "@/views/CategoriasZonas/CategoriasZonas.vue";
import TiposUbicaciones from "@/views/TiposUbicaciones/TiposUbicaciones.vue";
import Zonas from "@/views/Zonas/Zonas.vue";
import CubicationTypes from "@/views/CubicationTypes/CubicationTypes.vue";
import Printers from "@/views/Printers/Printers.vue";
import Roles from "@/views/Roles/Roles.vue";
import Productos from "@/views/Productos/Productos.vue";
import Rubros from "@/views/Rubros/Rubros.vue";
import SubRubros from "@/views/SubRubros/SubRubros.vue";
import TipoProductos from "@/views/TipoProductos/TipoProductos.vue";
import Proveedores from "@/views/Proveedores/Proveedores.vue";
import Asn from "@/views/Asn/Asn.vue";
import Asn_Recepcion from "@/views/Asn/Recepcion.vue";
import Docks from "@/views/Docks/Docks.vue";
import Lpn from "@/views/Lpn/Lpn.vue";
import Tasks from "@/views/Tasks/Tasks.vue";
import InventoryPorLPN from "@/views/Inventory/InventoryPorLPN.vue";
import InventoryPorUbicacion from "@/views/Inventory/InventoryPorUbicacion.vue";
import InventoryPorAtributo from "@/views/Inventory/InventoryPorAtributo.vue";
import Waves from "@/views/Waves/Waves.vue";
import PickingDetail from "@/views/PickingDetail/PickingDetail.vue";
import Reportes from "@/views/Reports/Reportes.vue";
import Settings from "@/views/Settings/index.vue";
import Webhooks from "@/views/Webhooks/Webhooks.vue";
import Packages from "@/views/Packages/PackingScreen.vue";
import Rules from "@/views/Rules/Rules.vue";

import Constant from "@/constants/sections";
import Ubicaciones from "@/views/Ubicaciones/Ubicaciones.vue";
import { path } from "ramda";
import AjusteManual from "@/views/Inventory/AjusteManual/AjusteManual.vue";
import Conteo from "@/views/Conteo/Conteo.vue";
import ConteoDetalle from "@/views/Conteo/Detalle.vue";
import ReceptionTypes from "@/views/ReceptionTypes/ReceptionTypes.vue";
import ShipmentOrders from "@/views/ShipmentOrders/ShipmentOrders.vue";
import PickingManagement from "@/views/PickingManagement/PickingManagement.vue";
import Incidencias from "@/views/Incidencias/Incidencias.vue";
// El acceso del cliente a "Inventario por LPN" depende de un flag propio del cliente
// (view_inventory_lpn), que viaja en app_object (ver GenericMixin.getAppObject()).
function clientHasInventoryLpnFlag() {
  try {
    const appObject = JSON.parse(localStorage.getItem("app_object"));
    return appObject?.view_inventory_lpn === true;
  } catch (e) {
    return false;
  }
}

/**
 * Routes applicant
 */
const routes_clients = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/",
    redirect: "/inventory/atributos",
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard",
    component: DashboardClient,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_ASN,
    component: Asn,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_PRODUCTS,
    component: Productos,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_SUBCLIENTS,
    component: SubClients,
    meta: { requiresAuth: true },
  },

  {
    path: "/" + Constant.SECTION_SHIPMENT_ORDERS,
    component: ShipmentOrders,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_WAVE,
    component: Waves,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_INVENTORY + "/atributos",
    component: InventoryPorAtributo,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_REPORTS,
    component: Reportes,
    meta: { requiresAuth: true },
  },
  ...(clientHasInventoryLpnFlag()
    ? [
        {
          path: "/" + Constant.SECTION_INVENTORY + "/lpn",
          component: InventoryPorLPN,
          meta: { requiresAuth: true },
        },
      ]
    : []),
  // Add this as the last route
  //redirect to home if page not found
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

/**
 * Routes general
 */
const routes_empleado = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/",
    redirect: "/dashboard",
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_EMPLOYEES,
    component: Employees,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_OPERATORS,
    component: Operators,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_ROLES,
    component: Roles,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_SUCURSALES,
    component: Sucursales,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_ALMACENES,
    component: Almacenes,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_CATEGORIAS_ZONAS,
    component: CategoriasZonas,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_CUBICATION_TYPES,
    component: CubicationTypes,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_CLIENTS,
    component: Clients,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_SUBCLIENTS,
    component: SubClients,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_TIPOS_UBICACIONES,
    component: TiposUbicaciones,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_ZONAS,
    component: Zonas,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_UBICACIONES,
    component: Ubicaciones,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_PRODUCTS,
    component: Productos,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_RUBROS,
    component: Rubros,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_SUBRUBROS,
    component: SubRubros,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_PRODUCT_TYPES,
    component: TipoProductos,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_SUPPLIER,
    component: Proveedores,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_RULES,
    component: Rules,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_CONTEO,
    component: Conteo,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_CONTEO + "/:id",
    component: ConteoDetalle,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_ASN,
    component: Asn,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_ASN + "/recepcion/:id",
    component: Asn_Recepcion,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_DOCKS,
    component: Docks,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_PRINTERS,
    component: Printers,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_LPN,
    component: Lpn,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_TASKS,
    component: Tasks,
    meta: { requiresAuth: true },
  },

  {
    path: "/" + Constant.SECTION_INVENTORY + "/lpn",
    component: InventoryPorLPN,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_INVENTORY + "/ubicacion",
    component: InventoryPorUbicacion,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_INVENTORY + "/atributos",
    component: InventoryPorAtributo,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_AJUSTE_MANUAL,
    component: AjusteManual,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_SHIPMENT_ORDERS,
    component: ShipmentOrders,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_WAVE,
    component: Waves,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_PICKING_DETAIL,
    component: PickingDetail,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_PICKING_MANAGEMENT,
    component: PickingManagement,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_REPORTS,
    component: Reportes,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_SETTINGS,
    component: Settings,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_WEBHOOKS,
    component: Webhooks,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_TIPOS_RECEPCION,
    component: ReceptionTypes,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_PACKAGES,
    component: Packages,
    meta: { requiresAuth: true },
  },
  {
    path: "/" + Constant.SECTION_INCIDENCIAS,
    component: Incidencias,
    meta: { requiresAuth: true },
  },
  // Add this as the last route
  //redirect to home if page not found
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

var routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/",
    redirect: "/dashboard",
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  // Add this as the last route
  //redirect to home if page not found
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

if (localStorage.getItem("user_type") == UserType.CLIENT) {
  routes = routes_clients;
} else if (localStorage.getItem("user_type") == UserType.SUPERUSER || localStorage.getItem("user_type") == UserType.EMPLOYEE) {
  routes = routes_empleado;
}

export default routes;
